import { render, staticRenderFns } from "./business_plan.vue?vue&type=template&id=31bfce2d&"
import script from "./business_plan.vue?vue&type=script&lang=js&"
export * from "./business_plan.vue?vue&type=script&lang=js&"
import style0 from "./business_plan.vue?vue&type=style&index=0&id=31bfce2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports